<!-- components/SpinnerOverlay.vue -->
<template>
  <div v-if="showSpinner" class="spinner-overlay">
    <div class="spinner"></div>
  </div>
</template>

<script>
import router from "@/router";
import { computed, watch } from "vue";
import store from "@/store";

export default {
  name: "SpinnerOverlay",
  setup() {
    const showSpinner = computed(() => store.state.showSpinner);
    const currentUser = computed(() => store.getters["auth/currentUser"]);
    watch(currentUser, () => {
      if (currentUser.value === null) {
        router.replace({ name: "login" });
      }
    });
    return {
      showSpinner,
    };
  },
};
</script>

<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  border: 8px solid rgba(0, 0, 0, 0.1); /* Light border */
  border-left-color: #b6300f; /* Primary color for the spinner */
  border-radius: 50%;
  width: 50px; /* Spinner size */
  height: 50px; /* Spinner size */
  animation: spin 1s linear infinite; /* Spin animation */
  margin-bottom: 20px; /* Space between spinner and text */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
